export { default } from './BulkAssignView';
